import Swiper from "swiper"
import {SwiperOptions} from "swiper/types"
import {Keyboard, Pagination, Navigation} from "swiper/modules"

const gallerySliders = document.querySelectorAll<HTMLElement>(".g-text-gallery")

gallerySliders.forEach((slider) => {
  const sliderPagination = slider.querySelector<HTMLElement>(".g-text-gallery__pagination");
  const slides = slider.querySelectorAll<HTMLElement>(".swiper-slide");
  const maxLength = 5;

  if (!slides ) return;

  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 24,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: slider.closest(".s-text-gallery")?.querySelector<HTMLElement>(".g-text-gallery__button.--next"),
      prevEl: slider.closest(".s-text-gallery")?.querySelector<HTMLElement>(".g-text-gallery__button.--prev"),
    },
    pagination: {
      el: sliderPagination,
      clickable: true,
      dynamicBullets: slides?.length > maxLength ? true : false,
      dynamicMainBullets: 3
    },
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
    },
  }

  new Swiper(slider, swiperSettings)
})
